import { AnyCardVisualization, CardAggregatedLineVisualization } from './cardModel';

export function isAggregatedLineVisualization(
    visualization: AnyCardVisualization
): visualization is CardAggregatedLineVisualization {
    return visualization.kind === 'line' && (visualization.aggregate ?? []).length > 0;
}
